import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import { LinkListProps } from './types';

import * as S from '../styled';

const SecondaryLinkList: React.FC<LinkListProps> = ({ links, onLinkClick }) => {
    const { t } = useTranslation();

    return (
        <>
            {links.map((link) => (
                <S.SecondaryLinkButton
                    data-locator={link.dataLocator}
                    href={link.to}
                    key={link.to}
                    onClick={() => onLinkClick(link.eventAction)}
                    {...link}
                >
                    <Text>{t(link.title)}</Text>
                </S.SecondaryLinkButton>
            ))}
        </>
    );
};

export default SecondaryLinkList;
